import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Radio,Modal } from "antd";
import { showComponent, tableDataSuccess } from "../../actions";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../utils/sessionUtil";
import {
  RadioButtonContainer,
  CancelButton,
  SaveButton,  
  ProfileTable,
  DefaultIndicator,
  ModalButtonContainer
} from "../../styles";
import {
  LinkTo
} from "../../../../CommonComponents/commonStyles";
import { accountChange } from "../../../../actions/globalActions";
import { recordError } from "../../../../utils/commonUtil";
import PropTypes from 'prop-types';
import { radioTableDerivedStates } from "../../selectors";
import moment from 'moment';
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";
class RadioTableComponent extends Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    selectedTableData: "",
    switchToTable: false,
    tableData: [],
    changedRadioButton: "",
    updatedRadioData: [],
    disable: false,
    modalVisible: false,
    accountId: "",
    selectedOption: { accountID: "" },
    grayedOut:true
  };

  // table starts
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter
    });
  };

  setAgeSort = () => {
    this.setState({
      sortedInfo: {
        order: "descend",
        columnKey: "accountNumber"
      }
    });
  };
  // table ends

  showModal = value => {
    this.setState({
      modalVisible: true,
      accountId: value
    });
  };  
  
  handleCancel = e => {
    this.setState({
      modalVisible: false
    });
  };

  handleDefaultClick = () => {
    this.props.history.push({
      pathname: '/'
    })
  }

  handleOk = e => {
    const { onAccountChange } = this.props;
    try {
      this.setState({
        modalVisible: false
      });
  
      onAccountChange({
        accountID: this.state.accountId.toString()
      });
    } catch (error) {
      recordError(error);
    }
  };

  compareByAlph = (a, b) => {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  };

  changeDefaultRow = () => { 
    
    this.state.prevTableData = this.props.RadioTableData.find((item)=> item.primary == 1);
    
    if(!this.state.prevTableData) this.state.prevTableData = this.state.selectedTableData[0];
    
    this.props.RadioTableData.forEach(obj => {
      if (obj.accountNumber === this.state.selectedTableData[0].accountNumber) {
        obj.primary = "1";
        this.state.updatedRadioData.push(obj);
      } else {
        obj.primary = "0";
        this.state.updatedRadioData.push(obj);
      }
    });

  };

  postData = () => {
    this.setState({grayedOut:true})
    this.changeDefaultRow();
    this.props.tableDataSuccess({
      changeDef: this.props.changeDefault,
      metaData : {
      method: "FORMDATA",
      url: `/donor-portal/api/profile/${getAccountData().partyId}/changeDefaultAccount`,
      page: "myProfile",
      data: {
        fromAccId: this.state.prevTableData.accountId,
        toAccId : this.state.selectedTableData[0].accountId
      }
    }})
  };

  render() {
    const RadioGroup = Radio.Group;
    let { sortedInfo} = this.state;
    sortedInfo = sortedInfo || {};
    const {RadioTableData, fromCsrUser } = this.props; 
    
       
   {RadioTableData.map(obj=>{      
       if(typeof RadioTableData != 'null' && typeof RadioTableData == 'object') {
         obj.dateOp= obj.dateOpened ? moment(moment.tz(parseInt(obj.dateOpened), "America/New_York")).format("MM/DD/YYYY"): '--';        
       obj.bal="$" +
    Number(obj.balance).toLocaleString(
          undefined,
           {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )
        } 
      })}  
    

      const defaultRadio = RadioTableData.map((item, index) => {
              if (item.primary == 1) {
                return index;
              }
            });


    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedTableData: selectedRows,
          changedRadioButton: selectedRowKeys,
          disable: false,
          grayedOut:false
        });
      },
      hideDefaultSelections: false,
      selectedRowKeys: this.state.changedRadioButton || defaultRadio,
      type: "radio"
    };

    const columndata = [
      {
        title: "Account Number",
        dataIndex: "accountNumber",
        key: "accountNumber",
        sorter: (a, b) => this.compareByAlph(a.accountNumber, b.accountNumber),
        sortOrder: sortedInfo.columnKey === "accountNumber" && sortedInfo.order
      },
      {
        title: "Account Name",
        dataIndex: "accountName",
        key: "accountName",
        sorter: (a, b) => this.compareByAlph(a.accountName, b.accountName),
        sortOrder: sortedInfo.columnKey === "accountName" && sortedInfo.order,        
        render: (value, record) => {
          if (record.primary == "1") {
            return (
              <span>
                <LinkTo onClick={() => {
                  try {
                    if(getPrimaryAccount().userId == record.accountId)
                      this.handleDefaultClick();
                    else
                      this.showModal(record.accountId);
                  } catch (error) {
                    recordError(error);
                  } 
                }}>
                  {value}
                </LinkTo>
                {<DefaultIndicator>DEFAULT</DefaultIndicator>}
              </span>
            );
          } else {
            return (
              <LinkTo onClick={() => { 
                try {
                  if(getPrimaryAccount().userId == record.accountId)
                    this.handleDefaultClick();
                  else
                    this.showModal(record.accountId);
                } catch (error) {
                  recordError(error);
                }
              }}>
                {value}
              </LinkTo>
            );
          }
        }
      },
      {
        title: "Date opened",
        dataIndex: "dateOp",
        key: "dateOp",
        sorter: (a, b) => this.compareByAlph(a.dateOp, b.dateOp),
        sortOrder: sortedInfo.columnKey === "dateOp" && sortedInfo.order
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        sorter: (a, b) => this.compareByAlph(a.role, b.role),
        sortOrder: sortedInfo.columnKey === "role" && sortedInfo.order
      },
      {
        title: "Access Level",
        dataIndex: "access",
        key: "access",
        sorter: (a, b) => this.compareByAlph(a.access, b.access),
        sortOrder: sortedInfo.columnKey === "access" && sortedInfo.order
      },
      {
        title: "Balances",
        dataIndex: "bal",
        key: "bal",
        sorter: (a, b) => this.compareByAlph(a.bal, b.bal),
        sortOrder: sortedInfo.columnKey === "bal" && sortedInfo.order
      }
    ];

    return (
      <div>
        <ProfileTable
          columns={columndata}
          rowClassName={(record, index) => {
             if((index % 2) == 0) return 'grayScale';
             else return 'whiteScale';
          }}
          dataSource={RadioTableData}
          onChange={this.handleChange}
          pagination={false}
          rowSelection={rowSelection}
        />
        <RadioButtonContainer>
          <GeneralButton
            type="functional"
            text="CANCEL"
            onClick={() => {
              try {
                this.props.showComponent();
                this.props.toggleisEnabled();
                this.props.analyticsTracking('cancel', this.props.eventaction(), 'Cancel');
              } catch (error) {
                recordError(error);
              }
            }}
            inverted={true}
            disabled={false}
            id="radioSaveBtn"
            width="9.375rem"
          />
          {
            !this.state.disable
            && <>
              <GeneralButton
                text="SAVE"
                type="functional"
                inverted={false}
                onClick={() => {
                  try {
                    this.postData();
                    this.props.toggleisEnabled();
                    this.props.analyticsTracking('save', this.props.eventaction(), 'Save');
                  } catch (error) {
                    recordError(error);
                  }
                }}
                disabled={isGeminiUser() ? (fromCsrUser ? this.state.grayedOut : true ) : this.state.grayedOut}
                width="9.375rem"
              />
              </>
          }
        </RadioButtonContainer>
        {RadioTableData.map(obj => {          
          if (this.state.accountId === obj.accountId) {
            return (
              <Modal
                title="Switch Account"
                visible={this.state.modalVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={[
                  <ModalButtonContainer>
                    <GeneralButton
                      text="Cancel"
                      onClick={this.handleCancel}
                      type="functional"
                      width="9.375rem"
                      inverted={true}
                      disabled={false}
                    />
                    <GeneralButton
                      text="Continue"
                      onClick={this.handleOk}
                      type="functional"
                      width="9.375rem"
                      inverted={false}
                      disabled={false}
                    />
                  </ModalButtonContainer>
                ]}
              >
                <p>
                  You are about to switch to account {obj.accountName}{" "}
                  <b>{obj.accountNumber}</b>
                  <br />
                  This will take you to the account page.
                  <br />
                  Do you want to continue?
                </p>
              </Modal>
            );
          }
        })}
      </div>
    );
  }
}

RadioTableComponent.propTypes = {
  eventaction: PropTypes.func,
  analyticsTracking: PropTypes.func,
  RadioTableData: PropTypes.arrayOf(PropTypes.object),
  toggleisEnabled: PropTypes.func,
  fromCsrUser: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {...radioTableDerivedStates(state.toJS())}
};

const mapDispatchToProps = dispatch => ({
  tableDataSuccess: data => dispatch(tableDataSuccess(data)),
  showComponent: () => dispatch(showComponent()),
  onAccountChange: data => dispatch(accountChange(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RadioTableComponent)
);
